export enum FilterType {
    fixed = 0,
    applied = 1,
}

export interface IFilter {
    name: string;
    value: string;
    type: FilterType;
}
